import { createStore } from "vuex";
import { STATE_MODULES } from "./state-modules";
import config from "./modules/config";
import quiz from "./modules/quiz";
import { AppState } from "@/models/SkillAssessmentAppState";

export default createStore<AppState>({
	modules: {
		[STATE_MODULES.CONFIG]: config,
		[STATE_MODULES.QUIZ]: quiz
	}
})
